export * from './customer-type-icon.component';
